import { createContext } from 'react';
import UiManager from '../app/ui/UiManager';
import setupActions from './actions';
import setupPages from './pages';
import setupRoutes from './routes';
import setupMenuItems from './menu_items';
const uiManager = new UiManager();

setupActions(uiManager);
setupPages(uiManager);
setupRoutes(uiManager);
setupMenuItems(uiManager);

export const UiManagerContext = createContext(uiManager);

export default uiManager;
